import React, { useState } from "react";

import Form_component from "./form_component/Form_component";

function Suggestions() {
 

  return (
    <>
      <Form_component/>
    </>
  );
}

export default Suggestions;
